import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
  forwardRef,
  inject,
  Injector
} from '@angular/core';
import {MatFormField, MatPrefix} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule
} from '@angular/forms';
import {MatTooltip} from '@angular/material/tooltip';
import {MatIcon} from '@angular/material/icon';
import {NgClass, NgStyle} from '@angular/common';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';

@Component({
  selector: 'app-select-one',
  standalone: true,
  imports: [
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    MatTooltip,
    MatIcon,
    MatPrefix,
    NgStyle,
    NgClass,
    ReactiveFormsModule,
    NgxMatSelectSearchModule

  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectOneComponent),
      multi: true
    }
  ],
  templateUrl: './select-one.component.html',
  styleUrl: './select-one.component.css'
})
export class SelectOneComponent implements ControlValueAccessor, OnChanges, OnInit {
  @Input() classe = '';
  @Input() listaInput: any[] = [];
  @Input() itemSelecionado: any;

  @Input() placeholder = '';
  @Input() campo = '';
  @Input() subCampo = '';

  @Input() font?: string;

  @Input() label?: string;
  @Input() colorLabel?: string;

  @Input() chaveCompare = '';

  @Input() iconPrefix?: string;
  @Input() iconColor?: string;

  @Input() widthFormField = '100%';
  @Input() heightFormField = '60px';

  @Input() backgroundColor?: string;
  @Input() borderColor?: string;

  @Input() carregandoInfo?: boolean = false;

  @Input() disabled = false;
  @Input() showValidationErrors = true;
  @Input() customErrorMessages?: Record<string, string>;

  @Output() selecionarItem = new EventEmitter<any>();

  @Input() pularPrimeiraSelecao = false;

  @Input() desselecionar = false;
  @Input() habilitarBusca = false;

  get panelClasses(): string[] {
    const classes = [`${this.classe}-panel`];
    if (this.habilitarBusca) {
      classes.push('app-select-scroll-panel');
    }
    return classes;
  }

  private onChange: (value: any) => void = () => { /* será */ };
  private onTouched = () => { /* será*/ };

  private _control: any;
  filtroControl = new FormControl();
  listaOriginal: any[] = [];

  compararListas = (v1: any, v2: any): boolean => {
    if (this.chaveCompare) {
      return v1 && v2 ? v1[this.chaveCompare] === v2[this.chaveCompare] || v1[this.chaveCompare] === v2 : v1 === v2;
    }

    return v1 && v2 && v1.id && v2.id ? v1.id === v2.id : v1 === v2;
  }

  private readonly injector = inject(Injector);

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes['itemSelecionado'] != 'undefined') {
      if (typeof changes['itemSelecionado'].currentValue != 'undefined') {
        this.itemSelecionado = changes['itemSelecionado'].currentValue;
      }
    }

    if (changes['listaInput']?.currentValue) {
      this.listaOriginal = [...changes['listaInput'].currentValue];
    }
  }

  ngOnInit(): void {
    if (this.itemSelecionado != null && this.pularPrimeiraSelecao == null){
      this.selecionarItem.emit(this.itemSelecionado);
    }
    try {
      this._control = this.injector.get(NgControl, null);
      this.listaOriginal = [...this.listaInput];
      this.filtroControl.valueChanges.subscribe(search => {
        this.filtrarLista(search);
      });
    } catch {
      // nada a fazer
    }
  }

  writeValue(value: any): void {
    this.itemSelecionado = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onChangeSelected() {
    this.selecionarItem.emit(this.itemSelecionado);
    this.onChange(this.itemSelecionado);
  }

  onSelectionChange() {
    this.onChangeSelected();
    this.onTouched();
  }

  get isInvalid(): boolean {
    return this._control?.invalid && this._control?.touched;
  }

  get errors(): any {
    return this._control?.errors;
  }

  getErrorMessage(): string {
    if (!this.errors) return '';

    if (this.customErrorMessages) {
      for (const errorKey of Object.keys(this.errors)) {
        if (this.customErrorMessages[errorKey]) {
          return this.customErrorMessages[errorKey];
        }
      }
    }

    if (this.errors['required']) {
      return `${this.label || 'Este campo'} é obrigatório`;
    }

    return 'Seleção inválida';
  }

  getDisplayText(item: any): string {
    if (!item) return '';

    if (this.campo) {
      if (this.subCampo) {
        return `${item[this.campo]} - ${item[this.subCampo]}`;
      }
      return item[this.campo];
    }

    return item.toString();
  }

  filtrarLista(search: string) {
    if (!search) {
      this.listaInput = [...this.listaOriginal];
      return;
    }
    search = search.toLowerCase();
    this.listaInput  = this.listaOriginal.filter(item =>
      this.getDisplayText(item)?.toLowerCase().includes(search)
    );
  }
}
